export default function initAccordions() {
  // accordions
  jQuery('.accordion__title').on('click', function (e) {
    e.preventDefault();
    let accordion = jQuery(this);
    if (!accordion.parent().hasClass('expanded')) {
      jQuery('.accordion-image__img').not(accordion.parent().find('.accordion-image__img')).fadeTo('fast', 0);
      jQuery('.accordion__content').not(accordion.next()).attr('aria-hidden', 'true').slideUp();
      jQuery('.accordion__title').not(accordion).attr('aria-expanded', 'false');
      jQuery('.accordion').not(accordion.parent()).removeClass('expanded');
      accordion.next().attr('aria-hidden', 'false').slideDown();
      accordion.attr('aria-expanded', 'true');
      accordion.parent().toggleClass('expanded');
      accordion.parent().siblings().find('.accordion-image__img').fadeTo('fast', 1);
    }
  });
}
